import { atom } from 'jotai';

enum SummaryStatus {
  INIT,
  GENERATING,
  GOT_LATEST_CONTENT,
}

const allEventList = atom<string[]>([]);
const summaryCollapse = atom<boolean>(false);
const status = atom<SummaryStatus>(SummaryStatus.INIT);
const copyTextAtom = atom<string>('Copy Response');
const selectedEventsAtom = atom<string[]>([]);
const eventFilterOnAtom = atom<boolean>(false);

export {
  allEventList,
  summaryCollapse,
  SummaryStatus,
  status,
  copyTextAtom,
  selectedEventsAtom,
  eventFilterOnAtom,
};
